import { securityInvitationsAcceptPostSlice } from './post';

export const {
	requestPostSecurityInvitationsAccept,
	resetPostSecurityInvitationsAccept
} = securityInvitationsAcceptPostSlice.asyncActionCreators;
